import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonItemOption } from "@ionic/vue";
import { computed } from "vue";

import InputAmountPerformance from "@/components/input/InputAmountPerformance.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { SliderOptionAmountProps } from "@/types/props";
import { SliderOptionAmountEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderOptionAmount',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    minValue: {},
    stepSize: {},
    limitOrderSize: {},
    directInputDisabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const model = computed<string | number | undefined>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', Number(value))
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItemOption), {
    color: _unref(ION_VARIANT).LIGHT
  }, {
    default: _withCtx(() => [
      _createVNode(InputAmountPerformance, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        min: __props.minValue,
        max: __props.limitOrderSize,
        "amount-step": __props.stepSize,
        "direct-input-disabled": __props.directInputDisabled
      }, null, 8, ["modelValue", "min", "max", "amount-step", "direct-input-disabled"])
    ]),
    _: 1
  }, 8, ["color"]))
}
}

})